import { useQueryList } from '@percent/admin-dashboard/common/hooks'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { Programs } from './Programs'
import { ProgramsContainerProps } from './ProgramsContainer.types'

export function ProgramsContainer({ partner }: ProgramsContainerProps) {
  const { validationSubmissionsService } = useServices()

  const [
    {
      dataOrNull: programs,
      isLoading: isProgramsLoading,
      errorMessageOrNull: programsError,
      totalResults: totalPrograms
    },
    { nextPage, previousPage, refresh }
  ] = useQueryList(validationSubmissionsService.getValidationSubmissionConfigurations, {
    partnerId: partner.id
  })

  return (
    <Programs
      programs={programs ?? []}
      isLoading={isProgramsLoading}
      errorMessage={programsError}
      partnerId={partner.id}
      totalPrograms={totalPrograms}
      nextPage={nextPage}
      previousPage={previousPage}
      refreshPrograms={refresh}
    />
  )
}
